import React from 'react';

/** Shown while a route chunk downloads — a thin accent progress line plus a breathing dot, on the page background. */
export function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-primary)' }} role="status" aria-live="polite" aria-label="Loading" data-testid="route-loading">
      <div className="fixed top-0 left-0 right-0 h-0.5 overflow-hidden" aria-hidden="true">
        <div className="h-full w-1/3 rounded-full" style={{ backgroundColor: 'var(--accent)', animation: 'route-bar 1.1s ease-in-out infinite' }} />
      </div>
      <span className="block w-3 h-3 rounded-full" style={{ backgroundColor: 'var(--accent)', animation: 'route-pulse 1.4s ease-in-out infinite' }} aria-hidden="true" />
      <style>{`
        @keyframes route-bar { 0% { transform: translateX(-100%); } 100% { transform: translateX(300%); } }
        @keyframes route-pulse { 0%, 100% { opacity: .35; transform: scale(.85); } 50% { opacity: 1; transform: scale(1); } }
        @media (prefers-reduced-motion: reduce) { [data-testid="route-loading"] * { animation: none !important; } }
      `}</style>
    </div>
  );
}
